import React from 'react'
import { Card, CardCoverPhoto, CardBody, CardFooter } from '@react/react-spectrum/Card'

import { EE } from '../../../config/constants'
import { getTimelineIcon, truncateWithEllipses } from '../../../config/lib'
import './TimelineComponents.scss'

export const CallCenter = ({ channel, event, tenantId }) => {
  return (
    <Card allowsSelection={false} className='timeline-components'>
      <CardCoverPhoto src='/cx/img/timelineCallCentre.svg' />
      <CardBody
        title={
          event.entity?.[tenantId]?.interactionDetails?.core?.callCenterAgent?.callTopic
            ? event.entity[tenantId].interactionDetails.core.callCenterAgent?.callTopic
            : 'Call Satisfaction'
        }
        subtitle={event.entity.eventType}
        description={
          event.entity[tenantId].interactionDetails.core.callCenterAgent?.callSatisfaction
            ? event.entity[tenantId].interactionDetails.core.callCenterAgent?.callSatisfaction + '/5'
            : event.entity[tenantId].interactionDetails.core.callCenterAgent?.callFeeling
        }
      />
      <CardFooter>
        <span className={'cardFooter-left'}>
          {new Date(event.entity.timestamp).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
        </span>
        <span className={'cardFooter-right'}>{getTimelineIcon(channel, event)}</span>
      </CardFooter>
    </Card>
  )
}

export const Checkout = ({ channel, event, tenantId }) => {
  const nbItems = event.entity.productListItems?.length
  let title
  let description

  if (!nbItems) {
    title = '0 items'
    description = '--'
  } else {
    title = `${event.entity.productListItems?.[0].name} ${nbItems > 1 ? 'and more' : ''}`
    description = `${nbItems} item${nbItems > 1 ? 's' : ''} - ${event.entity.productListItems
      .reduce((prev, cur) => prev + cur.priceTotal, 0)
      .toLocaleString('en-us', {
        style: 'currency',
        currency: event.entity.productListItems?.[0]?.currencyCode || 'USD',
      })}`
  }
  return (
    <Card allowsSelection={false} className='timeline-components'>
      <CardCoverPhoto
        src={event.entity.productListItems?.[0]?.[tenantId]?.core?.imageURL || '/cx/img/bag-shopping-solid.svg'}
      />
      <CardBody
        title={title}
        subtitle='Purchased'
        description={description}
      />
      <CardFooter>
        <span className={'cardFooter-left'}>
          {new Date(event.entity.timestamp).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
        </span>
        <span className={'cardFooter-right'}>{getTimelineIcon(channel, event)}</span>
      </CardFooter>
    </Card>
  )
}

export const AddToCart = ({ channel, event, tenantId }) => {
  return (
    <Card allowsSelection={false} className='timeline-components'>
      <CardCoverPhoto
        src={event.entity.productListItems?.[0]?.[tenantId].core.imageURL || '/cx/img/cart-shopping-solid.svg'}
      />
      <CardBody
        title={event.entity.productListItems?.[0].name}
        subtitle='Added To Cart'
        description={event.entity.productListItems?.[0]?.priceTotal?.toLocaleString('en-us', {
          style: 'currency',
          currency: event.entity.productListItems?.[0]?.currencyCode || 'USD',
        })}
      />
      <CardFooter>
        <span className={'cardFooter-left'}>
          {new Date(event.entity.timestamp).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
        </span>
        <span className={'cardFooter-right'}>{getTimelineIcon(channel, event)}</span>
      </CardFooter>
    </Card>
  )
}

export const ProductView = ({ channel, event, tenantId }) => {
  return (
    <Card allowsSelection={false} className='timeline-components'>
      <CardCoverPhoto
        src={event.entity.productListItems?.[0]?.[tenantId]?.core?.imageURL || '/cx/img/image-regular.svg'}
      />
      <CardBody
        title={event.entity.productListItems?.[0]?.name}
        subtitle='Viewed'
        description={event.entity.productListItems?.[0]?.priceTotal?.toLocaleString('en-us', {
          style: 'currency',
          currency: event.entity.productListItems?.[0]?.currencyCode || 'USD',
        })}
      />
      <CardFooter>
        <span className={'cardFooter-left'}>
          {new Date(event.entity.timestamp).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
        </span>
        <span className={'cardFooter-right'}>{getTimelineIcon(channel, event)}</span>
        <div></div>
      </CardFooter>
    </Card>
  )
}

export const Offer = ({ channel, event, tenantId }) => {
  return (
    <Card allowsSelection={false} className='timeline-components'>
      <CardCoverPhoto src={event.entity[tenantId]?.proposition?.image || '/cx/img/image-regular.svg'} />
      <CardBody
        title={event.entity.eventType === EE.OFFER_ACCEPTED ? EE.OFFER_ACCEPTED : EE.OFFER_DECLINED}
        subtitle={event.entity[tenantId]?.proposition?.name}
        description=''
      />
      <CardFooter>
        <span className={'cardFooter-left'}>
          {new Date(event.entity.timestamp).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
        </span>
        <span className={'cardFooter-right'}>{getTimelineIcon(channel, event)}</span>
      </CardFooter>
    </Card>
  )
}

export const GeoFencing = ({ channel, event, tenantId }) => {
  return (
    <Card allowsSelection={false} className='timeline-components'>
      <CardCoverPhoto src='/cx/img/map-location-dot-solid.svg' />
      <CardBody
        title={event.entity.eventType === EE.POI_ENTRY ? EE.POI_ENTRY : EE.POI_EXIT}
        subtitle={event.entity.placeContext?.POIinteraction?.poiDetail?.name}
        description=''
      />
      <CardFooter>
        <span className={'cardFooter-left'}>
          {new Date(event.entity.timestamp).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
        </span>
        <span className={'cardFooter-right'}>{getTimelineIcon(channel, event)}</span>
      </CardFooter>
    </Card>
  )
}

export const Chatbot = ({ channel, event, tenantId }) => {
  return (
    <Card allowsSelection={false} className='timeline-components'>
      <CardCoverPhoto src='/cx/img/robot-solid.svg' />
      <CardBody
        title='Chatbot interaction'
        subtitle={truncateWithEllipses(event.entity?.[tenantId]?.interactionDetails?.core?.bot?.botTopic, 25)}
        description=''
      />
      <CardFooter>
        <span className={'cardFooter-left'}>
          {new Date(event.entity.timestamp).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
        </span>
        <span className={'cardFooter-right'}>{getTimelineIcon(channel, event)}</span>
      </CardFooter>
    </Card>
  )
}

export const RegisterAccount = ({ channel, event, tenantId }) => {
  return (
    <Card allowsSelection={false} className='timeline-components'>
      <CardCoverPhoto src='/cx/img/user-plus-solid.svg' />
      <CardBody
        title={event.entity?.[tenantId]?.identification?.core?.email}
        subtitle='Account Registration'
        description=''
      />
      <CardFooter>
        <span className={'cardFooter-left'}>
          {new Date(event.entity.timestamp).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
        </span>
        <span className={'cardFooter-right'}>{getTimelineIcon(channel, event)}</span>
      </CardFooter>
    </Card>
  )
}

export const PageView = ({ channel, event, tenantId }) => {
  return (
    <Card allowsSelection={false} className='timeline-components'>
      <CardCoverPhoto src={event.image || '/cx/img/web.svg'} />
      <CardBody title={event.entity.web.webPageDetails.name} subtitle='Page View' />
      <CardFooter>
        <span className={'cardFooter-left'}>
          {new Date(event.entity.timestamp).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
        </span>
        <span className={'cardFooter-right'}>{getTimelineIcon(channel, event)}</span>
      </CardFooter>
    </Card>
  )
}

export const GenericEvent = ({ channel, event, tenantId }) => {
  return (
    <Card allowsSelection={false} className='timeline-components'>
      <CardCoverPhoto src={event.image || '/cx/img/comment-regular.svg'} />
      <CardBody title={event.entity.eventType} />
      <CardFooter>
        <span className={'cardFooter-left'}>
          {new Date(event.entity.timestamp).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
        </span>
        <span className={'cardFooter-right'}>{getTimelineIcon(channel, event)}</span>
      </CardFooter>
    </Card>
  )
}
